import React, { useState } from 'react'
import './createCategoryPopUp.css'
import axios from "../../axios";
export default function CreateCategoryPopUp({ setOpenSubject, data }) {
    const [categoryName, setCategoryName] = useState()
    const handleNewCategory = async () => {
        let body = {
            "CategoryName": categoryName,
            "contentInfoID": [],
            "visibility": true
        }
        let res = await axios.post(`/api/v1/cm/library/category/createCategory?chapter_id=${data}`, body);
        if (res.data.status === true) {
            window.location.reload();
        }
    }
    return (
        <div className='totalContainer_addContent_detail'>
            <div className='totalSubContainer_addContent_detail1  p-4'>
                <div className='addContent_heading'>
                    Add New Category
                </div>
                <div className='chapterName col-12 p-0 '>
                    <input maxLength={30} className='input_chapter  p-0' placeholder='Add category here' onChange={(e) => { setCategoryName(e.target.value) }} />
                </div>
                <div className='btnCont'>
                    <button className='add_to_libraryBtn_CmDCL' onClick={() => { setOpenSubject({ AddCategry: false }) }}>Discard</button>
                    <button onClick={() => { handleNewCategory() }} className={categoryName === undefined ? 'add_to_libraryBtn_Cm1Deactive' : 'add_to_libraryBtn_Cm1'} disabled={categoryName === undefined ? true : false}>Create</button>
                </div>
            </div>
        </div>
    )
}
